<template>
  <div>
    <van-search
      placeholder="搜商品名称"
      v-model="listQuery.key"
      @search="searchGoods"
    />
    <van-divider dashed>搜索结果</van-divider>

    <van-card
      v-for="(goods, index) in goodsList"
      :key="index"
      :price="goods.je"
      :desc="goods.commodity"
      :title="goods.spName"
      :thumb="goods.productPicture"
      @click="viewGoodsDetail(goods.id)"
    />
    <br /><br /><br />
  </div>
</template>

<script>
import {
  Divider,
  List,
  Toast,
  Cell,
  CellGroup,
  Card,
  Col,
  Icon,
  Row,
  Tab,
  Tabbar,
  TabbarItem,
  Tabs,
  Search,
} from "vant";

export default {
  components: {
    [Divider.name]: Divider,
    [List.name]: List,
    [Toast.name]: Toast,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Card.name]: Card,
    [Search.name]: Search,
  },
  data() {
    return {
      searchKey: "",
      loading: false,
      finished: false,
      goodsList: [],
      activeFooter: 1,
      listQuery: {
        page: 1,
        limit: 20,
        key: "",
      },
    };
  },
  created() {
    let spname = sessionStorage.getItem("spName");
    this.listQuery.key = spname;
    this.searchGoods(spname);
  },
  methods: {
    searchGoods(spName) {
      if (spName.indexOf("%") != -1) {
        Toast("禁止输入%,!,*等特殊符号");
        return;
      }
      let params = { spName: spName };

      let url = "/index/selectGoodsByName";
      return new Promise((resolve, reject) => {
        this.$axios
          .get(url, params)
          .then((data) => {
            this.goodsList = data.data;
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    viewGoodsDetail(id) {
      this.$router.push({ name: "goods", query: { id: id } });
    },
  },
};
</script>

<style lang="less">
.user {
  &-poster {
    width: 100%;
    height: 53vw;
    display: block;
  }

  &-group {
    margin-bottom: 15px;
  }

  &-links {
    padding: 15px 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;

    .van-icon {
      display: block;
      font-size: 24px;
    }
  }
}
</style>